import React, { useContext } from 'react';
import { Stack, Chip, Tooltip, Box } from '@mui/material';
import { IssuedManualsContext } from '../context';

interface SectionTagsProps {
  sectionId: string;
  accreditationTags: Record<string, string[]>;
  hasAwbSubscription: boolean;
}

const SectionTags: React.FC<SectionTagsProps> = React.memo(({ sectionId, accreditationTags, hasAwbSubscription }) => {
  const { showAccreditationTags } = useContext(IssuedManualsContext);

  if (
    !showAccreditationTags ||
    !hasAwbSubscription ||
    !accreditationTags[sectionId]?.length
  ) {
    return null;
  }

  return (
    <Stack
      direction='row'
      spacing={3}
      sx={{ py: 2 }}
    >
      <Chip
        label={accreditationTags[sectionId][0]}
        variant='filled'
        color='info'
      />
      {accreditationTags[sectionId].length > 1 && (
        <Tooltip
          title={
            <Box>
              {accreditationTags[sectionId].slice(1).map((tag, index) => (
                <Box key={`${tag}-${index}`}>{tag}</Box>
              ))}
            </Box>
          }
          placement='top'
        >
          <Chip
            label={`+${accreditationTags[sectionId].length - 1}`}
            variant='filled'
            color='info'
          />
        </Tooltip>
      )}
    </Stack>
  );
});

export default SectionTags;
